import {defineStore} from 'pinia'
import API from '@/api'

const userStore =  defineStore('userInfo', {
    state: () => ({
        user:{
            userName: "",
            dataAuthTime:"",
            shareToken: "",
            familyUser: false,
            registered: false,
            bizType: "dacal",
            maxtMemberAuth:{
                memberType: undefined,
                expire: new Date()
            }
        },
        loading: false
    }),
    actions: {

        /**
         *
         * @param deviceId {string}
         * @returns {Promise<ResultDTO<UserInfo>>}
         */
        async getUserInfo(deviceId) {
            try {
                this.loading = true;
                const response = await API.user.getUserInfo(deviceId)
                if(response.success && response.data){
                    Object.assign(this.user, response.data, {registered: true})
                    if(!this.user.maxtMemberAuth){
                        this.user.maxtMemberAuth = {
                            memberType: undefined,
                            expire: new Date()
                        }
                    }
                }else{
                    console.error('Error fetching users:', response);
                    this.loading = false;
                    return {success: false, data:null, errorMsg: 'error'}
                }

                return response;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching users:', error)
                return {success: false, data:null, errorMsg: 'error'}
            }finally {
                this.loading = false;
            }
        },
        /**
         *
         * @param userInfo {UserInfo}
         * @returns {Promise<ResultDTO>}
         */
        async doRegister(userInfo) {
            try {
                const response = await API.user.doRegister(userInfo)

                if(response.success){
                    Object.assign(this.user, response.data, {registered: true})
                    if(this.user.deviceId && this.user.deviceId.startsWith("family")){
                        this.saveDeviceId(this.user.deviceId);
                    }
                }else{
                    console.error('Error register users:', response);
                }

                return response;
            } catch (error) {
                console.error('Error fetching users:', error)
            }
        },

        saveDeviceId(deviceId) {
            localStorage.setItem('deviceId', deviceId);
        },
        saveAppVersion(appVersion) {
            localStorage.setItem('appVersion', appVersion);
        },
        saveXToken(xtoken) {
            localStorage.setItem('xtoken', xtoken);
        },
        getDeviceId(){
            return localStorage.getItem('deviceId');
        },
        getAppVersion(){
            return localStorage.getItem('appVersion');
        },
        saveBizType(bizType) {
            localStorage.setItem('bizType', bizType);
        },
        getBizType(){
            return localStorage.getItem("bizType");
        },
        saveDataType(dataType) {
            localStorage.setItem('dataType', dataType);
        },
        getDataType(){
            const dataType = localStorage.getItem("dataType");

            if(dataType === 'liaoyu') {
                return 'taqu';
            }
            return dataType;
        }
    },
});


export
{
    userStore
}
